// utils/extractAllowedUrls.js

export const extractAllowedUrls = (allowedFeatureList) => {
    const urls = [];

    allowedFeatureList?.forEach((item) => {
        if (item.feature?.protectedUrl) {
            urls.push(item.feature.protectedUrl);
        }

        if (Array.isArray(item.subFeatureList)) {
            item.subFeatureList.forEach((sub) => {
                if (sub.feature?.protectedUrl) {
                    urls.push(sub.feature.protectedUrl);
                }
            });
        }
    });

    return urls;
};
